import React from 'react';

import PopupActionButtons from '../../../PopupActionButtons';
import styles from './index.module.css';
// import { useEditorContext } from '../../context';

function PropertySelect({ onNextPage }) {
  // const {
  //   pageEntityEditorState,
  //   setPageEntityEditorState,
  //   handleCloseEntityEditor,
  //   handleAddAreaToEntity,
  // } = useEditorContext();

  return (
    <div className={styles.container}>
      <div>Select property</div>
      <PopupActionButtons onNextPage={onNextPage} />
    </div>
  );
}

export default PropertySelect;
